import { t } from '@gem/modules/i18n';
import { getAudioFileDuration } from '@gem/utils';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { FilePayload } from '../FilePayload/FilePayload';

export class AudioPayload extends FilePayload {
  constructor(data) {
    super(data);

    this.payloadType = PayloadType.AudioMessage;
    this.duration = data.duration;
    this.artist = data.artist;
    this.title = data.title;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      duration: this.duration,
      artist: this.artist || null,
      title: this.title || null,
    };
  }

  get typeDescription() {
    return t('common_audio_files');
  }

  async upload() {
    await super.upload();
    if (this.isLoaded && !this.duration) {
      this.duration = await getAudioFileDuration(this.url);
    }
  }
}
